import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/purchaseGoods.module.css";
import { durationObj } from "../../../../utils/constant";
import BarChart from "../../../../Components/GraphNCharts/BarChart";
import TableChart from "../../../../Components/GraphNCharts/TableChart";
import GlobalChart from "../../../../Components/GraphNCharts/GlobalChart";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import { get } from "../../../../utils/api";
import {
  generateBarChartDataSetForWaste,
  manipulateDataForBarChart,
} from "../../../../utils/graphFunctions";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import { generateMonthArray } from "../../../../utils/formatDate";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
} from "../../../../utils/common";
import useAuthStore from "../../../../store/ContextUser";
const Dashboard = () => {
  const currentDate = new Date();
  const {selectedCompany}= useAuthStore();
  const currentYear = currentDate.getFullYear();
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    emission: null,
    transportEmission: null,
    vehicleEmission: null,
    fuelEmission: null,
    transportionMode: null,
    vehicleType: null,
    fuelEfficiency: null,
    vendorAnalysis: null,
    temporalAnalysis: null,
    comparison: null,
    avgDistanceType: null,
  });
  const [error, setError] = useState(null);
  const [month, setMonth] = useState("1M");
  const [year, setYear] = useState("");
  const [tableData, setTableData] = useState();

  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [graphView, setGraphView] = useState({
    facility: "Annual",
    temporal: "Annual",
    totalWaterRecycled: "Year",
  });

  console.log("first", fromDate, toDate);

  const apiUrls = {
    emission: `/dashboard/scope3/employeecommute/totalEmissionFromEmployeeCommute?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    transportEmission: `/dashboard/scope3/employeecommute/emissionModeofTransportion?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    vehicleEmission: `/dashboard/scope3/employeecommute/emissionByVehicleType?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    fuelEmission: `/dashboard/scope3/employeecommute/totalEmissionPerFuelType?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    transportionMode: `/dashboard/scope3/employeecommute/transportionModeTravelAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    vehicleType: `/dashboard/scope3/employeecommute/vehicleTypeTravelAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    avgDistanceType: `/dashboard/scope3/employeecommute/avg-distance?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    fuelEfficiency: `/dashboard/scope3/employeecommute/fuelEfficiency?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    vendorAnalysis: `/dashboard/scope3/employeecommute/vendorAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    temporalAnalysis: `/dashboard/scope3/employeecommute/temporalAnalysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    comparison: `/dashboard/scope3/employeecommute/comparativeAndBenchmarking?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const [
        emission,
        transportEmission,
        vehicleEmission,
        fuelEmission,
        transportionMode,
        vehicleType,
        fuelEfficiency,
        vendorAnalysis,
        temporalAnalysis,
        comparison,
        avgDistanceType,
      ] = await Promise.all([
        get(apiUrls.emission),
        get(apiUrls.transportEmission),
        get(apiUrls.vehicleEmission),
        get(apiUrls.fuelEmission),
        get(apiUrls.transportionMode),
        get(apiUrls.vehicleType),
        get(apiUrls.fuelEfficiency),
        get(apiUrls.vendorAnalysis),
        get(apiUrls.temporalAnalysis),
        get(apiUrls.comparison),
        get(apiUrls.avgDistanceType),
      ]);
      console.log(avgDistanceType, "data12");

      setDashboardData({
        emission: emission.data,
        transportEmission: transportEmission.data,
        vehicleEmission: vehicleEmission.data,
        fuelEmission: fuelEmission.data,
        transportionMode: transportionMode.data,
        vehicleType: vehicleType.data,
        fuelEfficiency: fuelEfficiency.data,
        vendorAnalysis: vendorAnalysis.data,
        temporalAnalysis: temporalAnalysis.data,
        comparison: comparison.data,
        avgDistanceType: avgDistanceType?.data,
      });
    } catch (err) {
      setError("Error fetching data: " + err.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate,selectedCompany]);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/employeeCommuteMap?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month,selectedCompany]);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  const handleGraphChange = (e, type) => {
    if (type === "temporal") {
      setGraphView((prev) => ({ ...prev, temporal: e.target.value }));
    } else if (type === "facility") {
      setGraphView((prev) => ({ ...prev, facility: e.target.value }));
    } else if (type === "totalWaterRecycled") {
      setGraphView((prev) => ({ ...prev, totalWaterRecycled: e.target.value }));
    }
  };

  let barCharDataSet = [
    {
      label: "Industry Benchmarks",
      data: [650, 59, 800, 600, 450, 800, 300, 60, 120],
      backgroundColor: "rgba(255, 187, 51, 0.8)",
      borderColor: "rgba(255, 187, 51, 1)",
      borderWidth: 0.5,
    },
    {
      label: "Our Consumption",
      data: [150, 250, 400, 900, 300, 100, 320, 160, 100, 200, 150, 125],
      backgroundColor: "rgba(0, 102, 231, 0.8)",
      borderColor: "rgba(0, 102, 231, 1)",
      borderWidth: 0.5,
    },
  ];

  let vendorAnalysisColor = [
    { label: "Company", color: "rgba(255, 187, 51, 1)" },
    { label: "Personal", color: "rgba(0, 102, 231, 1)" },
  ];

  let comparisonAnalysisColor = [
    { label: "Bus", color: "rgba(254, 244, 48, 1)" },
    { label: "SUV", color: "rgba(146, 0, 183, 1)" },
    { label: "Scooter", color: "rgba(60, 215, 21, 1)" },
    { label: "Sedan", color: "rgba(255, 79, 79, 1)" },
  ];

  let businessTravelColor = [
    { label: "Road", color: "rgba(255, 79, 79, 1)" },
    { label: "Rail", color: "rgba(146, 0, 183, 1)" },
    { label: "Air", color: "rgba(14, 98, 224, 1)" },
    { label: "Ship", color: "rgba(60, 215, 21, 1)" },
  ];

  let vehicleTypeEmissionDataset = generateBarChartDataSetForWaste(
    dashboardData?.vehicleEmission?.data,
    "rgba(0, 81, 183, 1)",
    "Commute"
  );

  let fuelTypeEmissionDataset = generateBarChartDataSetForWaste(
    dashboardData?.fuelEmission?.data,
    "rgba(183, 77, 0, 1)",
    "Commute"
  );

  let transportModeDataset = generateBarChartDataSetForWaste(
    dashboardData?.transportionMode?.data,
    "rgba(0, 81, 183, 1)",
    "Trips"
  );

  let vehicleTypeDataset = generateBarChartDataSetForWaste(
    dashboardData?.vehicleType?.data,
    "rgba(183, 77, 0, 1)",
    "Employee Trips"
  );

  let fuelEfficiencyDataset = generateBarChartDataSetForWaste(
    dashboardData?.fuelEfficiency?.data[0]?.vehicleTypeData,
    "rgba(0, 81, 183, 1)",
    "Fuel Efficiency"
  );

  let vendorAnalysisDataset = manipulateDataForBarChart({
    data: dashboardData?.vendorAnalysis?.data,
    colors: vendorAnalysisColor,
    type: "vendoranalysis",
  });

  let comparisonDataset = manipulateDataForBarChart({
    data: dashboardData?.comparison?.data,
    colors: businessTravelColor,
    type: "travelmode",
  });

  let employeeCommuteDataset = manipulateDataForBarChart({
    data: dashboardData?.transportEmission?.data,
    colors: businessTravelColor,
    type: "employeeCommuteTransport",
  });
  console.log(
    dashboardData?.avgDistanceType?.data
      ?.map((el) => el?.avgDistance)
      ?.filter(Boolean),
    "data12"
  );
  let avgDistanceDataset =
    dashboardData?.avgDistanceType?.data
      ?.map((el) => el?.avgDistance)
      ?.filter(Boolean)?.length > 0
      ? generateBarChartDataSetForWaste(
          dashboardData?.avgDistanceType?.data,
          "#EB7E0E",
          "Average Distance"
        )
      : [];

  console.log(
    Object.values(
      dashboardData?.temporalAnalysis?.tenYearsEmission ?? {}
    )?.filter(Boolean)?.length > 0,
    "d112"
  );
  let temporalDataset =
    Object.values(
      dashboardData?.temporalAnalysis?.tenYearsEmission ?? {}
    )?.filter(Boolean)?.length > 0
      ? [
          {
            label: "Emission",
            data: Object.values(
              dashboardData?.temporalAnalysis?.tenYearsEmission ?? {}
            ),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ]
      : [];

  let annualTemporalDataset =
    dashboardData?.temporalAnalysis?.yearEmission
      ?.map((item) => item?.totalEmission)
      .filter(Boolean)?.length > 0
      ? [
          {
            label: "Emission",
            data: dashboardData?.temporalAnalysis?.yearEmission?.map((item) => {
              return item.totalEmission;
            }),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ]
      : [];

  console.log("dashboardData", dashboardData);
  console.log("dashboardData1", employeeCommuteDataset);

  return (
    <>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Employee Commute</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Emission Analysis</p>
        <div className={styles.card_container}>
          <p className={styles.graph_heading}>
            Total Emissions from Employee Commutes (tCO2e)
          </p>
          <p className={styles.card_value}>
            {formatNumberCommaSeparated(
              fixedTons(dashboardData?.emission?.totalEmission || 0)
            )}
          </p>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Emissions by Mode of Transportation (tCO2e)
              </p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(
                    dashboardData?.transportEmission?.totalEmission ?? 0
                  )
                )}{" "}
                <span>
                  (
                  {fixedPercentage(
                    dashboardData?.transportEmission?.yoyChange || 0
                  )}
                  % YOY)
                </span>
              </p>
            </div>
          </div>
          <BarChart
            datasets={employeeCommuteDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Emissions by Vehicle Type (tCO2e)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      dashboardData?.vehicleEmission?.totalEmission ?? 0
                    )
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.vehicleEmission?.percentageDifference >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.vehicleEmission?.percentageDifference || 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={vehicleTypeEmissionDataset}
              labels={dashboardData?.vehicleEmission?.data.map((item) => {
                return item.vehicleType;
              })}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Total Emissions per Fuel Type (tCO2e)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(dashboardData?.fuelEmission?.totalEmission ?? 0)
                  )}{" "}
                  <span
                    className={`${styles.percentage_difference} ${
                      dashboardData?.fuelEmission?.percentageDifference >= 0
                        ? styles.positive
                        : styles.negative
                    }`}
                  >
                    (
                    {fixedPercentage(
                      dashboardData?.fuelEmission?.percentageDifference || 0
                    )}
                    % YOY)
                  </span>
                </p>
              </div>
            </div>
            <BarChart
              datasets={fuelTypeEmissionDataset}
              labels={dashboardData?.fuelEmission?.data.map((item) => {
                return item.vehicleFuelType;
              })}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Mode of Travel Analysis</p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>Trasportation mode</p>
            </div>
            <BarChart
              datasets={transportModeDataset}
              labels={dashboardData?.transportionMode?.data.map((item) => {
                return item._id;
              })}
              yAxisTitle={"Number of Trips"}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <p className={styles.graph_heading}>Vehicle Type</p>
              </div>
            </div>
            <BarChart
              datasets={vehicleTypeDataset}
              labels={dashboardData?.vehicleType?.data.map((item) => {
                return item.vehicleOwnership;
              })}
              yAxisTitle={"Number of Employees"}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Geographical Analysis</p>

        <div className={styles.card_container_map}>
          <div className={styles.world_map_header_container}>
            <p className={styles.graph_heading}>Emission by Country</p>
            <div className={styles.input_date_loc_select_container}>
              <select
                name="month"
                id="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {durationObj?.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.label}
                  </option>
                ))}
              </select>

              {/* <select
                name="year"
                id="year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className={styles.heading_select_year}
              >
                {["World"].map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select> */}
            </div>
          </div>

          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChart tableData={tableData} />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart tableData={tableData} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>
          Fuel Efficiency and Distance Analysis
        </p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div>
                <p className={styles.graph_heading}>
                  Average Distance Covered (Km)
                </p>
                <p className={styles.graph_value}>
                  {formatNumberCommaSeparated(
                    fixedTons(
                      (dashboardData?.avgDistanceType?.data?.reduce(
                        (sum, item) => sum + (item.avgDistance || 0),
                        0
                      ) || 0) / 12
                    ) || 0
                  )}
                </p>
              </div>
            </div>
            <BarChart
              datasets={avgDistanceDataset}
              labels={generateMonthArray(fromDate, toDate)}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <div>
                  <p className={styles.graph_heading}>Fuel Efficiency</p>
                  <p className={styles.graph_value}>
                    {formatNumberCommaSeparated(
                      fixedTons(dashboardData?.fuelEfficiency?.value ?? 0)
                    )}
                    {" %"}
                    <span
                      className={`${styles.percentage_difference} ${
                        dashboardData?.fuelEfficiency?.percentageChange >= 0
                          ? styles.positive
                          : styles.negative
                      }`}
                    >
                      (
                      {fixedPercentage(
                        dashboardData?.fuelEfficiency?.percentageChange
                      ) || 0}
                      % YOY)
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <BarChart
              datasets={fuelEfficiencyDataset}
              labels={dashboardData?.fuelEfficiency?.data[0]?.vehicleTypeData.map(
                (item) => {
                  return item.vehicleType;
                }
              )}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Vendor Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Company-Provided vs. Personal Vehicles
              </p>
              <p className={styles.graph_value}>
                {fixedPercentage(
                  dashboardData?.vendorAnalysis?.thisYearPercentage ?? 0
                )}
                {"% "}
                <span
                  className={`${styles.percentage_difference} ${
                    dashboardData?.vendorAnalysis?.percentageDifference >= 0
                      ? styles.positive
                      : styles.negative
                  }`}
                >
                  (
                  {fixedPercentage(
                    dashboardData?.vendorAnalysis?.percentageDifference ?? 0
                  )}
                  % YOY)
                </span>
              </p>
            </div>
          </div>
          <BarChart
            datasets={vendorAnalysisDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
            yAxisTitle={"Emission in %"}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Temporal Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>Year-over-Year Comparison</p>
            </div>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.temporal}
                onChange={(e) => handleGraphChange(e, "temporal")}
                className={styles.heading_select_month}
              >
                {["Annual", "Year On Year"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <LineChart
            dataset={
              graphView?.temporal === "Annual"
                ? annualTemporalDataset
                : temporalDataset
            }
            labels={
              graphView?.temporal === "Annual"
                ? generateMonthArray(fromDate, toDate)
                : Object.keys(dashboardData?.temporalAnalysis?.tenYearsEmission)
            }
            yAxisTitle={"GHG Emissions (tCO2e)"}
            display={true}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>
          Comparative and Benchmarking Analysis
        </p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>Comparison of Travel Modes</p>
            </div>
          </div>
          <BarChart
            datasets={comparisonDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
